import React from 'react';
import { Trans } from '@lingui/react/macro';
import img from './404.png';
import theme from './NotFound.module.scss';
import { Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';

const NotFound: React.FC<{}> = () => {
    return (
        <div className={theme.container}>
            <h1>
                <Trans>404 - Page not found</Trans>
            </h1>

            <div className={theme.imageContainer}>
                <Thumbnail src={img} />
            </div>
        </div>
    );
};

export default NotFound;